"use client";
import { forwardRef as e } from "react";
import { jsx as t } from "react/jsx-runtime";
import * as n from "@radix-ui/react-switch";
//#region src/components/atoms/Switch/Switch.tsx
var r = e((e, r) => /* @__PURE__ */ t(n.Root, {
	"data-slot": "switch",
	...e,
	ref: r
}));
r.displayName = "SwitchRoot";
var i = e((e, r) => /* @__PURE__ */ t(n.Thumb, {
	"data-slot": "switch-thumb",
	...e,
	ref: r
}));
i.displayName = "SwitchThumb";
//#endregion
export { r as SwitchRoot, i as SwitchThumb };
